import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import { CloseSidenav, OpenSidenav } from '../actions/side-nav.actions';
import {
  BusinessGroupChanged,
  ClearSearchOptions,
  DeactivatedChanged,
  DisplayedNameChanged,
  EmailChanged,
  GetBusinessGroupsSuccess,
  GetSecGroupsSuccess,
  GetSecGroupSuccess,
  PanelStatusChanged,
  QuicksightChanged,
  SecurityGroupChanged,
  UserNameChanged,
} from '../actions/user-search.actions';
import { UserSearchState } from '../models/user.models';

const initialState: UserSearchState = {
  panelExpanded: true,
  userName: '',
  displayedName: '',
  email: '',
  securityGroups: '',
  securityGroupValues: [],
  securityGroup: '',
  businessGroups: '',
  businessGroupValues: [],
  businessGroup: '',
  deactivated: false,
  quicksight: false,
};

export const UserSearchReducer = createReducer(
  initialState,
  on(PanelStatusChanged, (state) => ({
    ...state,
    panelExpanded: !state.panelExpanded,
  })),
  on(OpenSidenav, (state) => ({
    ...state,
    sidenavStatus: true,
  })),
  on(CloseSidenav, (state) => ({
    ...state,
    sidenavStatus: false,
  })),
  on(GetSecGroupsSuccess, (state, { res }) => ({
    ...state,
    securityGroups: res,
    securityGroupValues: res.map((object: any) => object.securityGroupName),
  })),
  on(GetSecGroupSuccess, (state, { res }) => {
    let securityGroupValues: string[] = [...state.securityGroupValues];
    let groupName: string = '';
    state.securityGroups.map((secGroup: any) => {
      if (secGroup.securityGroupId === res.securityGroupId) groupName = secGroup.securityGroupName;
    });
    securityGroupValues.filter((secGroup) => secGroup !== groupName).push(res.securityGroupName);

    return {
      ...state,
      securityGroups: state.securityGroups.map((secGroup: any) =>
        secGroup.securityGroupId === res.securityGroupId ? res : secGroup,
      ),
      securityGroupValues,
    };
  }),
  on(GetBusinessGroupsSuccess, (state, { res }) => ({
    ...state,
    businessGroups: res,
    businessGroupValues: res.map((object: any) => object.businessGroupName),
  })),
  on(UserNameChanged, (state, { userName }) => ({
    ...state,
    userName,
  })),
  on(DisplayedNameChanged, (state, { displayedName }) => ({
    ...state,
    displayedName,
  })),
  on(EmailChanged, (state, { email }) => ({
    ...state,
    email,
  })),
  on(SecurityGroupChanged, (state, { securityGroup }) => ({
    ...state,
    securityGroup,
  })),
  on(BusinessGroupChanged, (state, { businessGroup }) => ({
    ...state,
    businessGroup,
  })),
  on(DeactivatedChanged, (state) => ({
    ...state,
    deactivated: !state.deactivated,
  })),
  on(QuicksightChanged, (state) => ({
    ...state,
    quicksight: !state.quicksight,
  })),
  on(ClearSearchOptions, (state) => ({
    ...state,
    userName: '',
    displayedName: '',
    email: '',
    securityGroup: '',
    businessGroup: '',
    deactivated: false,
    quicksight: false,
  })),
  on(ActiveComponentChanged, (state, { activeComponent }) => ({
    ...state,
    panelExpanded: true,
    userName: '',
    displayedName: '',
    email: '',
    securityGroup: '',
    businessGroup: '',
    deactivated: false,
    quicksight: false,
    securityGroups:
      activeComponent === 'UserSearchComponent' ||
      activeComponent === 'UserSecurityGroupsComponent' ||
      activeComponent === 'UserPolicyDocumentsComponent'
        ? state.securityGroups
        : '',
    securityGroupValues:
      activeComponent === 'UserSearchComponent' ||
      activeComponent === 'UserSecurityGroupsComponent' ||
      activeComponent === 'UserPolicyDocumentsComponent'
        ? state.securityGroupValues
        : [],
    businessGroups:
      activeComponent === 'UserSearchComponent' ||
      activeComponent === 'UserSecurityGroupsComponent' ||
      activeComponent === 'UserPolicyDocumentsComponent'
        ? state.businessGroups
        : '',
    businessGroupValues:
      activeComponent === 'UserSearchComponent' ||
      activeComponent === 'UserSecurityGroupsComponent' ||
      activeComponent === 'UserPolicyDocumentsComponent'
        ? state.businessGroupValues
        : [],
  })),
);
